import { useState, useRef, forwardRef, useMemo } from "react";
import DatePicker, { registerLocale } from "react-datepicker";
import es from "date-fns/locale/es";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";

import ArrowCircleIcon from "../../assets/svgs/arrow-circle.svg";
import RightArrowIcon from "../../assets/svgs/right-arrow.svg";

import styles from "./UserCardHeader.module.css";

registerLocale("es", es);

const CustomDateInput = forwardRef(({ onClick }, ref) => (
  <img
    ref={ref}
    onClick={onClick}
    src={RightArrowIcon}
    alt="Seleccionar fecha"
    className={styles.rightArrow}
    style={{ cursor: "pointer" }}
  />
));

const UserCardHeader = ({ selectedDate, onDateChange, empleado, isMobile }) => {
  const initialDate = moment(selectedDate, "YYYY-MM-DD").toDate();
  const [date, setDate] = useState(initialDate);
  const datePickerRef = useRef(null);

  const handleDateSelect = (selected) => {
    setDate(selected);
    onDateChange(moment(selected).format("YYYY-MM-DD"));
  };

  const handleOpenCalendar = () => {
    datePickerRef.current?.setOpen(true);
  };

  const { relative, formattedDate } = useMemo(() => {
    const today = moment().startOf("day");
    const dateObj = moment(date).startOf("day");
    const formatted = dateObj.format("D [de] MMMM");

    let rel = "";
    if (dateObj.isSame(today, "day")) rel = "hoy";
    else if (dateObj.isSame(moment(today).subtract(1, "day"), "day")) rel = "ayer";
    else if (dateObj.isSame(moment(today).add(1, "day"), "day")) rel = "mañana";

    return { relative: rel, formattedDate: formatted };
  }, [date]);

  const sublineContent = useMemo(
    () => (
      <>
        {relative ? (
          <>
            Estas son las estimaciones de {relative}{" "}
            <span className={styles.dateBold}>{formattedDate}</span>
          </>
        ) : (
          <>
            Estas son las estimaciones del{" "}
            <span className={styles.dateBold}>{formattedDate}</span>
          </>
        )}
      </>
    ),
    [relative, formattedDate]
  );

  return (
    <>
      {isMobile && (
        <div className={styles.datePickerContainer}>
          <div className={styles.datePickerWrapper}>
            <DatePicker
              selected={date}
              onChange={handleDateSelect}
              locale="es"
              inline
              calendarClassName={styles.customCalendarMobile}
            />
          </div>
        </div>
      )}

      <div
        className={`${styles.userCardHeader} ${isMobile ? styles.userCardHeaderMobile : ""
          }`}
      >
        <div className={styles.headerLeft}>
          <h1 className={`${styles.title} ${isMobile ? styles.titleMobile : ""}`}>
            Carga de trabajo del equipo
          </h1>

          <div className={`${styles.sublineRow} ${isMobile ? styles.sublineRowMobile : ""}`}>
            <p className={`${styles.subline} ${isMobile ? styles.sublineMobile : ""}`}>
              {sublineContent}
            </p>

            {!isMobile && (
              <span className={styles.datePickerInline}>
                <span className={styles.highlight} onClick={handleOpenCalendar} />
                <DatePicker
                  ref={datePickerRef}
                  selected={date}
                  onChange={handleDateSelect}
                  locale="es"
                  popperPlacement="top-end"
                  calendarClassName={styles.customCalendar}
                  customInput={<CustomDateInput />}
                />
              </span>
            )}
          </div>
        </div>

        <div className={styles.headerButtons}>
          <a href="/" style={{ textDecoration: "none" }}>
            <button className={styles.userButton}>
              Cambiar a usuario
              <img
                src={ArrowCircleIcon}
                alt="Cambiar a usuario"
                className={styles.userIcon}
              />
            </button>
          </a>
        </div>
      </div>
    </>
  );
};

export default UserCardHeader;
